import { render, staticRenderFns } from "./SocialNetworksTab.vue?vue&type=template&id=1bb5f8f6&scoped=true&"
import script from "./SocialNetworksTab.vue?vue&type=script&lang=js&"
export * from "./SocialNetworksTab.vue?vue&type=script&lang=js&"
import style0 from "./SocialNetworksTab.vue?vue&type=style&index=0&id=1bb5f8f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb5f8f6",
  null
  
)

export default component.exports